import { getServerDataJsonObject } from '../global.js';
import DataTable from 'datatables.net-dt';
DataTable.ext.errMode = 'none';
import { swiper_update_height} from "../sliders/sliders.js";
import {chartInvest} from "../charts/chartInvest.js";
import { getLanguageUrlPrefix } from "../helpers/translations.js";

(function ($) {
    let langPrefix = getLanguageUrlPrefix();

    $(document).on('preInit.dt', function (e, settings) {
        $('.dt-search').parent('.dt-layout-cell').parent('.dt-layout-row').addClass('search-row');
        $('.dt-paging').parent('.dt-layout-cell').parent('.dt-layout-row').addClass('pagination-row').hide();
    });
    function table_add_dark_light (datatable){
        let trs = datatable.rows(':not(js-toggle--appeared-tr)', {
            search: 'applied',
            order: 'current'
            }).nodes();
        
        $(trs).each(function (i, tr) {
            $(tr).removeClass('dark light');
            $(tr).addClass(i % 2 ? 'light' : 'dark');
        });
    }
    let history_table_url = '/engine/function/investment/history_investments.php';
    let history_table = new DataTable(`[data-action="${history_table_url}"] table`, {
        ajax: history_table_url,
        processing: true,
        drawCallback: function (settings) {
            table_add_dark_light(history_table);
            swiper_update_height();
        },
        language: {
            url: `/template/js/lib/datatables/${langPrefix}.json`
        },
        columns: [
            {
                data: 'id',
                orderable: false
            },
            {
                data: 'link_to_investment',
                orderable: false
            },
            { data: 'commission' },
            { data: 'investment_value' },
            { data: 'max_bet' },
            { data: 'cof' },
            { data: 'bets_count' },
            { data: 'mid_bets' },
            { data: 'investment_status' },
            {
                data: 'profit',
                render: function (data, type, row) {
                    return `<span class="${data > 0 ? 'c-green' : 'c-red'}">${data}</span>`;
                }
            }
        ],
        order: [],
        "initComplete": function (settings, json) {
            $(`[data-action="${history_table_url}"]`).find('.pagination-row').show();
            swiper_update_height();
        }
    });


    let investments_table_url = '/engine/function/investment/active_investments.php';
    let investments_table = new DataTable(`[data-action="${investments_table_url}"] table`, {
        ajax: investments_table_url,
        processing: true,
        drawCallback: function (settings) {
            table_add_dark_light(investments_table);
            swiper_update_height();
        },
        language: {
            url: `/template/js/lib/datatables/${langPrefix}.json`
        },
        columns: [
            {
                data: 'id',
                orderable: false
            },
            {
                data: 'link_to_investment',
                orderable: false
            },
            { data: 'commission' },
            { data: 'investment_value' },
            {
                data: 'profit',
                render: function (data, type, row) {
                    return `<span class="${data > 0 ? 'c-green' : 'c-red'}">${data}</span>`;
                }
            },
            { data: 'coins_now' },
            { data: 'max_bet' },
            { data: 'cof' },
            { data: 'bets_count' },
            { data: 'mid_bets' },
            { data: 'last_bet' }
        ],
        order: [],
        "initComplete": function (settings, json) {
            $(`[data-action="${investments_table_url}"]`).find('.pagination-row').show();
            swiper_update_height();
        }
    });



    let page = 0;
    update_top_users();
    async function update_top_users() {
        let $div_wrapper = $('div.invest');
        let $load_more = $div_wrapper.siblings('.btn-load');
        $load_more.addClass('loading disabled');
        let url = 'https://' + window.location.host + $div_wrapper.data('action')+`?page=${page}`;
        let postData = ``;
        let data_json = await getServerDataJsonObject(url, postData);
        if (!data_json || !data_json.content_html) {
            return;
        }
        if (page === 0) {
            $div_wrapper.html('');
        }
        $div_wrapper.append(data_json.content_html);
        chartInvest();
        $load_more.removeClass('loading disabled');
        if (data_json.current_page >= data_json.pages_count-1) {
            $load_more.hide();
        } else {
            $load_more.show();
        }
        swiper_update_height();
        page++;
    }


    $('div.invest').parent().on('click', '.btn-load', function () {
        update_top_users();
    });

})(jQuery);